import { CKTextFieldNext, CKTextFieldNextProps } from 'clearkit';
import { FC } from 'react';

export type TextFieldWithValidationsProps = CKTextFieldNextProps & {
  name: string;
  validationErrors: Record<string, string[] | undefined>;
};

const TextFieldWithValidations: FC<TextFieldWithValidationsProps> = function({
  children,
  name,
  validationErrors,
  variant,
  ...rest
}) {
  const errors = validationErrors[name];

  return (
    <CKTextFieldNext {...rest} variant={errors ? 'error' : variant}>
      {errors?.map((message) => (
        <CKTextFieldNext.ErrorMessage>{message}</CKTextFieldNext.ErrorMessage>
      ))}
      {children}
    </CKTextFieldNext>
  );
};
export default TextFieldWithValidations;
